import {
  PlateSampleParamType,
  PlateSampleType,
} from '@/common/queries/selections/plateSample/plateSample.type';
import { fetchApi } from '@/config/axiosSetting';

export const getPlateSampleFunction = (
  param: PlateSampleParamType,
): Promise<PlateSampleType[]> => {
  return fetchApi.get('/selection_item/plate_sample/wop_list/', {
    params: {
      vehicle_type: param?.type,
      insurance: param?.insurance,
      plate_type: param?.plate_type,
      plate_design: param?.plate_design,
    },
  });
};
